<template>
    <api-delivery-card :icon="faRobot">
        <template v-slot:title>
            Automation
        </template>
        <template v-slot:headerRight>
            <vx-button v-if="props.automationRule" :href="`/automation/event/${props.automationRule.id}`" target="_blank"
                    size="sm" color="muted-light">Edit <font-awesome-icon widthAuto :icon="faArrowUpRight" /></vx-button>
        </template>

        <template v-slot:content>
            <div v-if="props.automationRule === undefined" class="w-full flex items-center justify-center">
                <vx-icon-loading spin></vx-icon-loading>
            </div>
            <template v-else-if="props.automationRule">
                <div class="text-slate-500 text-xl font-normal break-all">{{ props.automationRule.name }}</div>
            </template>
            <div v-else
                class="w-full p-4 bg-slate-50 rounded-[10px] justify-start items-center gap-3 inline-flex">
                <font-awesome-icon widthAuto :icon="faGhost" class="text-slate-500" />
                <div class="text-sky-950 text-sm font-normal">Automation missing</div>
            </div>
        </template>
    </api-delivery-card>
</template>
<script setup>
import ApiDeliveryCard from './ApiDeliveryCard.vue';
import { VxButton, VxIconLoading } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faRobot, faArrowUpRight, faGhost } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
    automationRule: {
        type: Object,
        required: false,
    },
});
</script>
